/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { IHistoryResponse, IAdminHistory } from '../../api/types';
import { GET_ADMIN_HISTORY } from '../../actions';

export type AdminHistoryState = IHistoryResponse<IAdminHistory>;

const initialState = {
  content: [],
  loading: false,
} as IHistoryResponse<IAdminHistory>;
const generic = genericReducers<AdminHistoryState>();
const adminHistory: IReducers<AdminHistoryState> = {
  [GET_ADMIN_HISTORY[REQUEST]]: generic.get.request,
  [GET_ADMIN_HISTORY[SUCCESS]]: generic.get.success,
  [GET_ADMIN_HISTORY[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, adminHistory);
